import Vue from 'vue'
import Router from 'vue-router'
import login from '@/views/login'
import formDesign from '@/views/formDesign'
import store from '@/store/index.js'
Vue.use(Router)
const router = new Router({
  routes: [
    {
      "name": "/",
      "path": "/",
      "component": () => import('@/views/homePage'),
    },
    {
      path: '/login',
      name: 'login',
      component: login
    },
    {
      "name": "/formDesign",
      "path": "/formDesign",
      "component": () => import('@/views/formDesign'),
    }, {
      "name": "/processDesign",
      "path": "/processDesign",
      "component": () => import('@/views/processDesign'),
    },
    {
      "name": "/changePass",
      "path": "/changePass",
      "component": () => import('@/views/changePass'),
    },
    {
      "name": "/oaSystem",
      "path": "/oaSystem",
      "component": () => import('@/views/oaSystem'),
    },
    {
      "name": "/personal",
      "path": "/personal",
      "component": () => import('@/views/personal'),
    },
    {
      "name": "/basicInfo",
      "path": "/basicInfo",
      "component": () => import('@/components/packages/FlowDesign/BasicInfo'),
    },
    {
      "name": "/flowSetting",
      "path": "/flowSetting",
      "component": () => import('@/components/packages/FlowDesign/FlowSetting'),
    },
    {
      "name": "/design",
      "path": "/design",
      "component": () => import('@/views/formDesign/design.vue'),
    },
    {
      "name": "/startProcess",
      "path": "/startProcess",
      "component": () => import('@/views/startProcess'),
    },
    {
      "name": "/startProcess",
      "path": "/startProcess",
      "component": () => import('@/views/startProcess'),
    },
    {
      "name": "/orgWork",
      "path": "/orgWork",
      "component": () => import('@/views/orgManage/orgWork'),
    },
    {
      "name": "/jobMag",
      "path": "/jobMag",
      "component": () => import('@/views/orgManage/jobMag'),
    },
    {
      "name": "/workExtent",
      "path": "/workExtent",
      "component": () => import('@/views/orgManage/workExtent'),
    },
    {
      "name": "/departmentMag",
      "path": "/departmentMag",
      "component": () => import('@/views/orgManage/departmentMag'),
    },
    {
      "name": "/peopleMag",
      "path": "/peopleMag",
      "component": () => import('@/views/orgManage/peopleMag'),
    },
    {
      "name": "/groupingMag",
      "path": "/groupingMag",
      "component": () => import('@/views/orgManage/groupingMag'),
    },
    {
      "name": "/roleMag",
      "path": "/roleMag",
      "component": () => import('@/views/orgManage/roleMag'),
    },
    {
      "name": "/menuMag",
      "path": "/menuMag",
      "component": () => import('@/views/menuMag'),
    },
    {
      "name": "/DataDic",
      "path": "/DataDic",
      "component": () => import('@/views/DataDic'),
    },
    {
      "name": "/templateType",
      "path": "/templateType",
      "component": () => import('@/views/templateType'),
    },
    {
      "name": "/templateMag",
      "path": "/templateMag",
      "component": () => import('@/views/templateMag'),
    },
    {
      "name": "/flow",
      "path": "/flow",
      "component": () => import('@/views/templateMag/flow'),
    },
  ]
})
router.beforeEach((to, from, next) => {
  let arr = ['/login']   //配置需要全屏展示的路由
  if (arr.includes(to.path)) {
    store.commit('menu/changeValue', { 'key': 'totalOrPart', 'value': 1 })
  } else {
    store.commit('menu/changeValue', { 'key': 'totalOrPart', 'value': 2 })
  }
  next(); // 必须调用 next() 才能继续路由跳转
});
export default router



// WEBPACK FOOTER //
// ./src/router/index.js